import _ from 'lodash'

/*
 * Helpers for reading the user_access document.
 *
 * These replace per-component evaluate-and-setState logic that had two failure
 * modes. It reset read access on every path but not write access, so a user who
 * selected a writable client and then a read-only one kept write access from the
 * previous selection. And it reached straight into userAccess.clients.write, so
 * a user_access document missing a 'clients' or 'tenants' key threw a TypeError
 * and blanked the page.
 *
 * Everything here is a pure function of the current arguments, so a stale value
 * is not representable, and every unknown shape denies rather than throws.
 *
 * This is UI-layer only. Firestore rules remain the enforcement point.
 */

export const isAdministrator = userAccess =>
  Boolean(userAccess && userAccess.administrator === true)

/**
 * @param userAccess the user_access document, may be null/undefined
 * @param scope      'tenants' | 'clients' | 'stores'
 * @param id         the tenant/client/store id, may be null/undefined
 */
export const canWrite = (userAccess, scope, id) => {
  if (isAdministrator(userAccess)) {
    return true
  }
  if (!userAccess || !id) {
    return false
  }
  const bucket = userAccess[scope]
  return Boolean(bucket) && _.includes(bucket.write, id)
}

export const canRead = (userAccess, scope, id) => {
  // Write access implies read access.
  if (canWrite(userAccess, scope, id)) {
    return true
  }
  if (!userAccess || !id) {
    return false
  }
  const bucket = userAccess[scope]
  return Boolean(bucket) && _.includes(bucket.read, id)
}
